<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {};
  },
  methods: {},
  components: {},
  mounted() {
    // const baseURL =
    //   process.env.NODE_ENV === "production"
    //     ? ""
    //     : process.env.NODE_ENV === "dev"
    //     ? "BACKEND_URL_PLACEHOLDER"
    //     : "http://192.168.1.80:9090";
    const baseURL =
      process.env.NODE_ENV === "production"
        ? "": "http://192.168.2.86:9090";
    const jujiParams = {
      baseURL,
    };
    window.jujiParams = jujiParams;
  },
};
</script>

<style lang="scss">
@import "./assets/scss/_common.scss";
@import "~@/assets/iconfont/iconfont.css";
#app {
  width: $width;
  height: $height;
}
body {
  font-family: "Microsoft YaHei";
}
.el-dialog__wrapper {
  .el-dialog {
    border-radius: 10px;
  }
}
</style>
